import React from "react";

import styles from "./SummaryCardLayout.css";

export default function SummaryCardLayout({ children, image }) {
  return (
    <div className={styles.root}>
      {image && (
        <div className={styles.image}>
          {image}
        </div>
      )}
      <div className={styles.main}>
        {children}
      </div>
    </div>
  );
}
